//GJ20241211:
//
//This file contains modifications to the cart drawer (AMP Upsells) to not allow SKUs from product add-ons to be removable or have the quantity changed as they need to only be attached to the main product.
//This is called in theme.liquid. Please do not modify or remove without speaking to Geoff (geoff@alljigsawpuzzles.co.uk).

var PRODUCT_TYPE_TO_HIDE = "AMP_HIDDEN";

function hideQtySelector(prodTitle) {
  const cartItems = document.querySelectorAll(".amp-cart__cart-lines .amp-cart__cart-line");

  cartItems.forEach(item => {
      let amp_item_title = item.querySelector(".amp-cart__cart-line-details-top div h2")?.innerText;  
      const prodTitleClean = prodTitle.replace(/\s+/g, " "); // remove extra spaces in title
    
      if (prodTitleClean === amp_item_title) {
        const qtySelectors = item.querySelector('.amp-cart__line-quantity-selector');
        const removeBtn = item.querySelector('.amp-cart__cart-line-remove');

        if (qtySelectors) {
            qtySelectors.style.display = 'none';
        }
        if (removeBtn) {
          removeBtn.style.display = 'none';
        }
      }
  });
}

function removeTitleLink(target) {
  const cartTitles = document.querySelectorAll('.amp-cart__cart-lines .amp-cart__cart-line-details-top > div > h2');
  
  cartTitles.forEach((title)=>{
  if(title.innerText == target){
      console.log("Found H2")
      title.style.pointerEvents = 'none';
    }
  })
}

function ampResetItem (prodTitle) {
  const cartItems = document.querySelectorAll(".amp-cart__cart-lines .amp-cart__cart-line");
  
  cartItems.forEach(item => {
    let amp_item_title = item.querySelector(".amp-cart__cart-line-details-top div h2")?.innerText;
    const prodTitleClean = prodTitle.replace(/\s+/g, " "); // remove extra spaces in title
    
    if (prodTitleClean === amp_item_title) {
      const qtySelectors = item.querySelector('.amp-cart__line-quantity-selector');
      const removeBtn = item.querySelector('.amp-cart__cart-line-remove');
      const itemTitle = item.querySelector('.amp-cart__cart-line-title');
      
      if (qtySelectors) {
        qtySelectors.style.display = 'flex';
      }
      if (removeBtn) {
        removeBtn.style.display = 'flex';
      }
      if (itemTitle) {
        itemTitle.style.pointerEvents = 'auto';
      }
    }
  });
}

async function fetchCart() {
  try {
    const response = await fetch('/cart.js', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    });

    if (!response.ok) {
        throw new Error(`Error fetching cart: ${response.statusText}`);
    }

    const cartData = await response.json();
    for (const item of cartData.items) {
      console.log("AMP ITEMS:", item)
      
        const productTitle = item.product_title; 

        const productResponse = await fetch(`/products/${item.handle}.js`);
        const productData = await productResponse.json();

        // Check if the product type matches the type to hide
        if (productData.type === PRODUCT_TYPE_TO_HIDE) {
            console.log(`Hiding controls for: ${productTitle}`);
            hideQtySelector(productTitle); 
            removeTitleLink(productTitle);
        } else {
            console.log('Resetting Item: ', productTitle);
            ampResetItem(productTitle);
          }
        }
        ampAddClearCartLink()
        return cartData;
    } catch (error) {
      console.error("Error:", error);
      return null;
  }
}

function ampAddClearCartLink () {
  const ampCartLines = document.querySelector('.amp-cart-drawer .amp-cart__cart-lines');
  if (document.querySelector('.amp-clear-cart-link')) return
  if (ampCartLines) {
    const clearElement = document.createElement('p');
    clearElement.classList.add('amp-clear-cart-link');
    clearElement.textContent = 'Clear Basket';
    
    clearElement.addEventListener('click', e => {
      fetch(`${window.Shopify.routes.root}cart/clear.js`, {
        method: 'POST',
      })
        .then(response => response.json())
        .then(data => {
          console.log('AMP UPSELL CART CLEARED');
        })
        .catch(error => {
          console.error('Error clearing amp upsell cart:', error);
        });
    });
    
    ampCartLines.insertAdjacentElement('afterend', clearElement);
  }
}

function ampToggleClearCartLink (count) {
  const ampCartClearLink = document.querySelector('.amp-cart-drawer .amp-clear-cart-link');
  
  if (ampCartClearLink) {
    if (count > 0) {
      ampCartClearLink.style.display = 'block';
    } else {
      ampCartClearLink.style.display = 'none';
    }
  }
}

window.AMP_CART_LOADED = cart => {
  ampAddClearCartLink();
  ampToggleClearCartLink(cart.item_count);
}

window.AMP_CART_UPDATED = cart => {
  fetchCart();
  ampToggleClearCartLink(cart.item_count);
}

window.AMP_CART_OPENED = () => {
  fetchCart();
}

/*document.addEventListener(
"mousedown",
function (event) {
const button = event.target.closest('button.pwAddToCart, button.pwAddToCart *');

if (button) {
console.log("clicked")
  event.preventDefault();
  event.stopPropagation();

  try {
      setTimeout(function () {
        window.AMP_API.OPEN_CART()
      }, 600);
  } catch (err) {
    console.error(err); // Log the error
  }
}
},
false
);*/